import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fe1f20c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("保存")

import {
    reactive,
    ref,
    watch,
    withDefaults
  } from 'vue'
  import type { ElForm } from 'element-plus'
  import { Project } from '@/types/project'

  interface Props {
    modelValue?: boolean;
    editProject: Project;
  }
  interface Emits {
    (e: "submit", project: Project): void;
    (e: "update:model-value", value: boolean): void;
  }
  type FormInstance = InstanceType<typeof ElForm>
  
export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { type: Boolean, required: false, default: false },
    editProject: { type: null, required: true }
  },
  emits: ["submit", "update:model-value"],
  setup(__props: any, { emit }: { emit: ({
    (e: "submit", project: Project): void;
    (e: "update:model-value", value: boolean): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: boolean, editProject: Project }
  

  

  const formRef = ref<FormInstance>();

  const form = reactive({
    name: '',
  });

  const rules = reactive({
    name: [
      {
        required: true,
        message: 'プロジェクト名を入力してください',
        trigger: 'blur',
      },
    ],
  });

  watch(() => props.modelValue, (value: boolean) => {
    if (value) {
      form.name = props.editProject.name;
    }
  })

  const handleSubmit = (formEl: FormInstance | undefined): void => {
    if (!formEl) return

    formEl.validate(async (valid) => {
      if (valid) {
        const project: Project = {
          id: props.editProject.id,
          name: form.name,
          deleted_flg: props.editProject.deleted_flg
        };

        emit('submit', project);
      }
    });
  }
  const handleClosed = (): void => {
    emit('update:model-value', false);
  }

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.modelValue,
    onClosed: handleClosed,
    title: "編集",
    width: "30%",
    "destroy-on-close": ""
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (handleSubmit(formRef.value)))
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref: (_value, _refs) => {
          _refs['formRef'] = _value
          formRef.value = _value
        },
        model: _unref(form),
        rules: _unref(rules),
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "プロジェクト名",
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(form).name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).name) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})